module.exports = __webpack_public_path__ + "static/media/seaplaneport_marker_dark_blue.414d159f.svg";